<section class="section">
  <header *ngIf="section.title">
    <h2>{{ section.title }}</h2>
    <hr />
  </header>

  <div class="section-content">
    <!-- Main content column -->
    <section class="section-main">
      <div class="section-main-card">
        <ng-container *ngFor="let card of section.cards">

          <!-- Text, List, Pharmacological handled by app-card -->
          <app-card *ngIf="card.kind === 'text'
                || card.kind === 'list'
                || card.kind === 'pharmacological'" [card]="card" [headingLevel]="3">
          </app-card>

          <!-- Specialized cards -->
          <app-differential-card *ngIf="card.kind === 'differential'" [card]="card" [headingLevel]="3">
          </app-differential-card>

          <app-sequelae-card *ngIf="card.kind === 'sequelae'" [card]="card" [headingLevel]="3">
          </app-sequelae-card>

          <app-involvement-card *ngIf="card.kind === 'involvement'" [card]="card" [headingLevel]="3">
          </app-involvement-card>

        </ng-container>
      </div>
    </section>

    <!-- Side margin panel -->
    <aside class="section-margin-panel" *ngIf="section.marginPanel">
      <app-margin-panel *ngIf="section.marginPanel" [cards]="section.marginPanel.cards">
      </app-margin-panel>
    </aside>
  </div>
</section>
